<script lang="ts">
  import type { TicketEvent } from "../../../types/ticket";

  export let s;
  export let marginTop;
  export let ticketEvent: TicketEvent;
  import { replaceWithAnchors } from "../../../lib/conversation";
</script>

<div class={s.flexEnd} style={`margin-top: ${marginTop}`}>
  <div class={s.chatBubbleMe}>
    <span class={s.variableTextColor}>
      {@html replaceWithAnchors((ticketEvent.payload.text || '').replace(/</g, "&lt;"))}
    </span>
  </div>
</div>
